import React from "react";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { formatteraTal } from "../Shared/Utils";

const strings = getStrings().component.common;

export const Price = (props: { amount: number, showFractions?: boolean }) => {

	const hasFractions = props.amount % 1 !== 0;

	const fractionDigits = hasFractions && props.showFractions ? 2 : 0;

	return <>{formatteraTal(props.amount, strings.sek, fractionDigits, fractionDigits)}</>;
}